<template>
    <div class="onboarding-tooltips" v-if="!tooltipsCompleted">
      <tooltip
        v-for="(tooltipModel, index) in tooltips"
        :key="index"
        :text="tooltipModel.text"
        :reference-element-id="tooltipModel.referenceElementId"
        :arrow-position="tooltipModel.arrowPosition"
        :placement="tooltipModel.placement"
        :confirm-text="tooltipModel.confirmText"
        :isActive="tooltipIndex === index"
        :offset="tooltipModel.offset"
        :width="tooltipModel.width"
        :paddingRight="tooltipModel.paddingRight"
        :is-onboarding="true"
        v-show="ifReferenceElementExist(tooltipModel.referenceElementId)"
        @next="nextTooltip"
        @close="closeTooltips"
      />
    </div>
</template>
<script setup lang="ts">
import { onMounted, ref } from 'vue'
import Tooltip from '@/components/onboarding/Tooltip.vue'
import { Placement } from '@popperjs/core'
import { useEndUserProfileStore } from '@/store/user-profile'
import { usePersistedStorage } from '@/composables/UsePersistedStorage'

interface TooltipModel {
  referenceElementId: string
  text: string,
  placement: Placement
  confirmText: string,
  offset?: number,
  width?: number,
  paddingRight?: number
}
const userStore = useEndUserProfileStore()
const { persistedStorage } = usePersistedStorage()

const tooltipStorageKey = `onboarding.tooltips.completed.${userStore.userId}`
const tooltipsCompleted = ref(persistedStorage.getItem(tooltipStorageKey) === 'true')
const tooltipIndex = ref(-1)

const nextTooltip = () => {
  tooltipIndex.value++
  if (tooltipIndex.value >= tooltips.length) {
    closeTooltips()
  }
}
const ifReferenceElementExist = (id: string) => document.getElementById(id)

const closeTooltips = () => {
  tooltipsCompleted.value = true
  persistedStorage.setItem(tooltipStorageKey, 'true')
}

const tooltips: TooltipModel[] = [
  {
    referenceElementId: 'muteToggle',
    text: 'Turn sound off and change tracks here',
    placement: 'top',
    confirmText: 'Next',
    width: 160,
    paddingRight: 20
  },
  {
    referenceElementId: 'orientationSwitcher',
    text: 'Choose the size of your video here',
    placement: 'top',
    confirmText: 'Next',
    offset: 70
  },
  {
    referenceElementId: 'actionMenu',
    text: 'Find royalty-free content, text and effects here',
    placement: 'left',
    confirmText: 'Next',
    width: 169
  },
  {
    referenceElementId: 'exportButton',
    text: 'When you’re done, hit export to render your video in the chosen size',
    placement: 'top',
    confirmText: 'Okay',
    offset: -32,
    width: 220
  }
]

onMounted(() => {
  tooltipIndex.value++
})

</script>
<style lang="scss">
.onboarding-tooltips {
  position: absolute;
  height: 0px;
  width: 0px;
}
</style>
